import { t, Trans } from '@lingui/macro'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import clsx from 'clsx'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from '../FileContextMenu/FileContextMenu.module.scss'
import { useSortLinks } from '../FileRoute/utils/sortParamToSortBy'
import itemStyles from './FileSortMenu.module.scss'
const debug = Debug('jotta:obos:FileSortMenu')
export interface FileSortMenuProps {
  children: ReactNode
}

export const FileSortMenu = observer<FileSortMenuProps>(function FileSortMenu({
  children,
  ...props
}) {
  const { sortLinks: links, replace } = useSortLinks()
  const nav = useNavigate()
  return (
    <DropdownMenu.Root data-testid="FileSortMenu" modal={false}>
      <DropdownMenu.Trigger
        aria-label={t`Sort`}
        className={styles.trigger}
        {...props}
      >
        {children}
      </DropdownMenu.Trigger>

      <DropdownMenu.Content className={styles.content}>
        <DropdownMenu.Arrow className={styles.arrow} />

        <DropdownMenu.Item
          className={clsx(styles.menuitem, itemStyles.menuitem, {
            [itemStyles.active]: links.name.active,
          })}
          onSelect={() =>
            nav(links.name.to.encodedPath, {
              replace,
            })
          }
        >
          <span className={styles.textSmall}>
            <Trans>Name</Trans>
          </span>
        </DropdownMenu.Item>
        <DropdownMenu.Item
          className={clsx(styles.menuitem, itemStyles.menuitem, {
            [itemStyles.active]: links.modified.active,
          })}
          onSelect={() =>
            nav(links.modified.to.encodedPath, {
              replace,
            })
          }
        >
          <span className={styles.textSmall}>
            <Trans>Modified</Trans>
          </span>
        </DropdownMenu.Item>
        <DropdownMenu.Item
          className={clsx(styles.menuitem, itemStyles.menuitem, {
            [itemStyles.active]: links.size.active,
          })}
          onSelect={() =>
            nav(links.size.to.encodedPath, {
              replace,
            })
          }
        >
          <span className={styles.textSmall}>
            <Trans>Size</Trans>
          </span>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
})
